import React from 'react'
import { AuthProvider } from '@maui-mf/common-react'
import { App } from './App'
import env from '@maui-mf/env'
import { AUTH_REDIRECT_PATH } from '@maui-mf/common-auth'

const redirectUri = new URL(AUTH_REDIRECT_PATH, env.MAUI_HOST)

export default function Root() {
  return (
    <AuthProvider
      clientId={env.MAUI_IDP_CLIENT_ID}
      host={env.MAUI_IDP_HOST}
      redirectUri={redirectUri.toString()}
    >
      <App />
    </AuthProvider>
  )
}
